import React from "react";
import SettingsTab from "../SettingsTab";
import {
  Spinner,
  Button,
  Intent,
  FormGroup,
  Callout,
  InputGroup,
  TextArea
} from "@blueprintjs/core";
import styles from "./ProgramSettings.module.scss";
import { Toolbar, ToolbarGroup } from "../../../molecules/Toolbar";
import SettingsForm from "../SettingsForm";
import FormInfo from "../../../atoms/FormInfo/FormInfo";
import FormHeading from "../../../atoms/FormHeading/FormHeading";
import { CopyInput } from "../../../atoms/CopyInput";
import { Icon } from "../../../atoms/Icon";
import { useProgramHighlights } from "./hooks";
import BrandPagePreview from "./BrandPagePreview";

export default function ProgramSettings() {
  const {
    account,
    rows,
    onChangeInput,
    addRow,
    deleteRow,
    programHighlight,
    setProgramHighlight,
    saveChanges,
    onCancel,
    loading,
    error,
    isSaving,
    isSaveEnabled,
    isPreviewOpen,
    setIsPreviewOpen,
    isPreviewReady
  } = useProgramHighlights();

  const username = (account && account.username) || "";

  if (loading) {
    return (
      <SettingsTab centered>
        <Spinner />
      </SettingsTab>
    );
  }

  return (
    <SettingsTab>
      <Toolbar title="Settings">
        <ToolbarGroup>
          <Button
            text="Cancel"
            style={{ marginRight: "10px" }}
            intent={Intent.NONE}
            loading={isSaving}
            disabled={!isSaveEnabled}
            onClick={onCancel}
          />
          <Button
            text="Save"
            intent={Intent.PRIMARY}
            loading={isSaving}
            disabled={!isSaveEnabled}
            onClick={saveChanges}
          />
        </ToolbarGroup>
      </Toolbar>

      <SettingsForm>
        {error && (
          <Callout
            icon="error"
            intent={Intent.DANGER}
            title="We couldn't save your settings."
            className={styles.error}
          >
            {error.message}
          </Callout>
        )}

        <FormHeading weight="600" size={16}>
          Program Highlights
        </FormHeading>
        <FormInfo>
          Video Squirrel can display program highlights to influencers who might
          be interested in partnering with you.
          <br />
          <br /> Fill out as much info as you can below to provide more info to
          influencers and entice them to work with you.
        </FormInfo>

        <FormGroup label="Brand URL" className={styles.brandURL}>
          <CopyInput
            value={`${window.location.origin}/brand/${username}`}
            message="Brand URL copied to clipboard."
          />
        </FormGroup>

        <FormGroup label="Checklist for brand">
          {rows.map((value, i) => {
            const onlyOneRow = rows.length === 1;
            return (
              <div className={styles.checkListRow}>
                <InputGroup onChange={onChangeInput(i)} value={value} />
                <Icon
                  name="plus"
                  size={22}
                  color="#2c2c2c"
                  className={styles.addIcon}
                  onClick={() => addRow(i)}
                />
                <Icon
                  name="trash"
                  size={18}
                  className={styles.deleteIcon}
                  color={onlyOneRow ? "#ced9e0" : "#db3737"}
                  onClick={() => deleteRow(i)}
                />
              </div>
            );
          })}
        </FormGroup>

        <FormGroup label="Program Highlight">
          <TextArea
            className={styles.programTextArea}
            value={programHighlight}
            onChange={setProgramHighlight}
          />
        </FormGroup>
        <BrandPagePreview
          programHighlight={programHighlight}
          programFeatures={rows.filter((row) => !!row.trim())}
          isOpen={isPreviewOpen}
          onDismiss={() => setIsPreviewOpen(false)}
        />

        <Button
          text="Preview"
          intent={Intent.PRIMARY}
          disabled={!isPreviewReady}
          onClick={() => setIsPreviewOpen(true)}
        />
      </SettingsForm>
    </SettingsTab>
  );
}
